import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { ReactReduxContext } from 'react-redux';

import getInjectors from './reducerInjectors';

/**
 * Dynamically injects a reducer
 *
 * @param {string} key A key of the reducer
 * @param {function} reducer A reducer that will be injected
 *
 */
export default ({ key, reducer }) =>
  (WrappedComponent) => {
    class ReducerInjector extends React.Component {
      static WrappedComponent = WrappedComponent;

      constructor(props, context) {
        super(props, context);

        getInjectors(context.store).injectReducer(key, reducer);
      }

      render() {
        return <WrappedComponent {...this.props} />;
      }
    }

    ReducerInjector.contextType = ReactReduxContext;
    ReducerInjector.displayName = `withReducer(${
      ReducerInjector.WrappedComponent.displayName ||
      ReducerInjector.WrappedComponent.name ||
      'Component'
    })`;

    return hoistNonReactStatics(ReducerInjector, WrappedComponent);
  };

const useInjectReducer = ({ key, reducer }) => {
  const context = React.useContext(ReactReduxContext);
  React.useEffect(() => {
    // @NOTE-DP: do not inject the reducers in storybook so the init action is not triggered
    if (!window.STORYBOOK_ENV) {
      getInjectors(context.store).injectReducer(key, reducer);
    }
  }, []);
};

export { useInjectReducer };
